import Suspense from "components/shared/Suspense";
import { Drawer } from "features/Drawer";
import { lazy, useRef, useState } from "react";
import { EditionSerializersEditionByline } from "types/serializers";

const EditablePageProgressDrawer = lazy(
  () => import("./EditablePageProgressDrawer")
);

export default function EditablePageProgress({
  currentPages,
  edition,
  message,
  onChange,
  pages,
}: Readonly<{
  currentPages: number | null;
  edition: EditionSerializersEditionByline;
  message?: string;
  onChange: (progress: number) => Promise<unknown>;
  pages: number | null;
}>) {
  const portalRef = useRef<HTMLDivElement>();
  const buttonRef = useRef<HTMLButtonElement>();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div ref={portalRef}>
      <button
        type="button"
        className="font-semibold underline decoration-dotted"
        data-tooltip-id="tooltip"
        data-tooltip-content="Click to update"
        ref={buttonRef}
        onClick={() => setIsEditing(true)}
      >
        {currentPages ? currentPages.toLocaleString() : "0"}
      </button>

      {isEditing && portalRef?.current && buttonRef?.current ? (
        <Suspense
          fallback={
            <Drawer.Loading
              settings={{
                ref: buttonRef.current,
                portalRef: portalRef.current,
                onClose: () => {},
                isOpen: true,
                offset: [-20, 10],
              }}
            />
          }
        >
          <EditablePageProgressDrawer
            attachElement={buttonRef.current}
            currentPages={currentPages}
            edition={edition}
            message={message}
            onChange={onChange}
            onDone={() => setIsEditing(false)}
            pages={pages}
            portalElement={portalRef.current}
          />
        </Suspense>
      ) : (
        false
      )}
    </div>
  );
}
